<h1 class="text-center" mat-dialog-title>{{ data.title | translate }}</h1>
<div class="d-flex justify-content-center spinner-dialog-overflow" mat-dialog-content matDialogClose>
  <mat-spinner></mat-spinner>
</div>
